import { render, staticRenderFns } from "./behavior-analyse.vue?vue&type=template&id=82a9a398&scoped=true&"
import script from "./behavior-analyse.vue?vue&type=script&lang=js&"
export * from "./behavior-analyse.vue?vue&type=script&lang=js&"
import style0 from "./behavior-analyse.vue?vue&type=style&index=0&id=82a9a398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a9a398",
  null
  
)

export default component.exports